import React from 'react';
import { AlertCircleBoldSmall as AlertCircleBoldSmallCE } from '@wix/wix-ui-icons-common/classic-editor';
import { WixBaseUiEnvironmentContext } from '../../../util/WixBaseUiEnvironment/WixBaseUiEnvironment';
import { iconColorByEditor } from '../iconsColors';
var AlertCircleBoldSmall = function AlertCircleBoldSmall(_ref) {
  var color = _ref.color;
  var context = React.useContext(WixBaseUiEnvironmentContext);
  var iconColor = '';
  if (color && (iconColorByEditor["".concat(color, "-RE")] || iconColorByEditor["".concat(color, "-CE")])) {
    iconColor = (context === null || context === void 0 ? void 0 : context.theme) === 'responsive' ? iconColorByEditor["".concat(color, "-RE")] : iconColorByEditor["".concat(color, "-CE")];
  }
  return /*#__PURE__*/React.createElement(AlertCircleBoldSmallCE, {
    color: iconColor
  });
};
AlertCircleBoldSmall.displayName = 'AlertCircleBoldSmall';
export default AlertCircleBoldSmall;